import MandateORM from "@/store/orm-axios/models/Mandate";
import BuildingORM from "@/store/orm-axios/models/Building";
import MeetingORM from "@/store/orm-axios/models/Meeting";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import MajorityORM from "@/store/orm-axios/models/Majority";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";

export default {
  methods: {
    async onMeetingStartCreated() {
      if (this.$route.params.id) {
        this.meetingId = this.$route.params.id;
        await MeetingORM.api()
          .GET(this.meetingId)
          .catch(err => {
            this.$fire({
              title: "MeetingORM FETCH",
              text: err,
              type: "error",
            });
          });
        var meeting = MeetingORM.find(this.meetingId);

        if (this.meetingIsNotClosed(meeting)) {
          await MandateORM.api()
            .FETCH(this.meetingId)
            .catch(err => {
              this.$fire({
                title: "MandateORM FETCH",
                text: err,
                type: "error",
              });
            });
          if (!this.participantAlreadyPresentPhysical()) {
            await BuildingORM.api()
              .GET(meeting.building_id)
              .catch(err => {
                this.$fire({
                  title: "BuildingORM FETCH",
                  text: err,
                  type: "error",
                });
              });
            await BuildingLotORM.api()
              .FETCH(meeting.building_id)
              .catch(err => {
                this.$fire({
                  title: "BuildingLotORM FETCH",
                  text: err,
                  type: "error",
                });
              });
            await MajorityORM.api()
              .FETCH(this.agencyId)
              .catch(err => {
                this.$fire({
                  title: "MajorityORM FETCH",
                  text: err,
                  type: "error",
                });
              });
            await VotingCategoryORM.api()
              .FETCH(meeting.building_id)
              .catch(err => {
                this.$fire({
                  title: "VotingCategoryORM FETCH",
                  text: err,
                  type: "error",
                });
              });
            await MeetingResolutionORM.api()
              .FETCH(meeting.id)
              .catch(err => {
                this.$fire({
                  title: "MeetingResolutionORM FETCH",
                  text: err,
                  type: "error",
                });
              });

            await this.setMeetingDetails(meeting);

            this.isLoading = false;
          } else {
            this.accessDenied();
          }
        } else {
          this.accessDenied();
        }
      } else {
        this.$router.push({
          name: "meetings",
        });
      }
    },
    meetingIsNotClosed(meeting) {
      return (
        meeting &&
        (meeting.status == this.meetingStatuses.invitationSent ||
          meeting.status == this.meetingStatuses.started ||
          meeting.status == this.meetingStatuses.completed)
      );
    },
    participantAlreadyPresentPhysical() {
      var mandate = MandateORM.query()
        .where(md => {
          return md.meeting_id == this.meetingId && md.building_owner_id == this.building_owner_id;
        })
        .first();
      var representedMandates = MandateORM.query()
        .where(md => {
          return (
            md.meeting_id == this.meetingId &&
            md.building_owner_id !== this.building_owner_id &&
            (md.representant_owner_id === this.building_owner_id ||
              md.representant_contact_id === this.contact_id)
          );
        })
        .get();

      var allRepresentedMandates = [];
      if (mandate) allRepresentedMandates.push(mandate);
      representedMandates.forEach(md => {
        allRepresentedMandates.push(md);
      });

      var someArePresentPhysical = this.$_.some(allRepresentedMandates, md => {
        return (
          md.presence_status == this.mandatePresenceStatuses.physical ||
          md.presence_status == this.mandatePresenceStatuses.pouvoir
        );
      });
      return !!someArePresentPhysical;
    },
    accessDenied() {
      this.$fire({
        text: "Access denied",
        title: "ERROR",
        type: "error",
        timer: 2000,
      });
      this.$router.push({
        name: "meetings",
      });
    },
  },
};
